import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-16 px-4 bg-white" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border-4 border-pastel-yellow rounded-[2.5rem] p-8 md:p-12 text-center relative bg-pastel-yellow/10" data-id="element-50">
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 text-7xl bg-white rounded-full p-2" data-id="element-51">
            🛡️
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mt-6 mb-4" data-id="element-52">
            Garantía de 7 Días
          </h2>

          <p className="text-xl text-gray-700 font-medium" data-id="element-53">
            Estamos tan seguros de que esta guía te encantará, que te ofrecemos
            7 días de garantía. Si no es lo que esperabas, te devolvemos tu
            dinero.{' '}
            <strong className="text-brand-purple" data-id="element-54">¡Sin preguntas!</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}